export default __webpack_public_path__ + "static/media/jeans6.ba0dc3c6.jpeg";